import Vue from "vue";
import Notifications from 'vue-notification'
import App from "./App.vue";
import { BootstrapVue } from 'bootstrap-vue'

import "bootstrap/dist/css/bootstrap.css";
import 'bootstrap-vue/dist/bootstrap-vue.css'
import "font-awesome/less/font-awesome.less";


Vue.config.productionTip = false;

Vue.use(Notifications)
Vue.use(BootstrapVue)

new Vue({
  render: h => h(App)  
}).$mount("#app");

